import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  name: 'Martín López',
  age: 38,
  specialty: 'Abogado Civil',
  city: 'Córdoba',
  quote: 'Desde que implementé Estudio Jurídico Listo, dejé de perder clientes por falta de seguimiento. El sistema se paga solo.'
}, {
  name: 'Lucía Fernández',
  age: 42,
  specialty: 'Abogada Penal',
  city: 'Rosario',
  quote: 'Este sistema me devolvió la tranquilidad. Ahora sé exactamente en qué estado está cada caso sin depender de mi memoria.'
}, {
  name: 'Santiago Ruiz',
  age: 35,
  specialty: 'Abogado Laboral',
  city: 'Buenos Aires',
  quote: 'Las plantillas y la estructura son oro puro. Pude tomar más casos trabajando menos horas.'
}, {
  name: 'Carolina Méndez',
  age: 45,
  specialty: 'Abogada de Familia',
  city: 'Mendoza',
  quote: 'Esto es simple, directo y funciona. Por fin siento que tengo el control total de mi despacho.'
}, {
  name: 'Diego Morales',
  age: 31,
  specialty: 'Abogado Comercial',
  city: 'La Plata',
  quote: 'Lo implementé en menos de una semana. Cambió por completo la imagen profesional que damos. 100% recomendado.'
}];
export function TestimonialsSection() {
  return <section className="bg-navy-light py-8 md:py-24 px-4 relative overflow-hidden" data-id="element-155">
      <div className="max-w-6xl mx-auto" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-16" data-id="element-157">
          <h2 className="text-2xl md:text-5xl font-black text-white mb-2 md:mb-6" data-id="element-158">
            Colegas que ya transformaron su estudio
          </h2>
          <p className="text-sm md:text-xl text-gray-400" data-id="element-159">
            Resultados reales de abogados en Argentina
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6" data-id="element-160">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-dark p-4 md:p-8 rounded-xl md:rounded-2xl border border-gold/20 relative group hover:border-gold/50 transition-colors" data-id="element-161">
              <QuoteIcon className="absolute top-4 right-4 w-6 h-6 md:w-10 md:h-10 text-gold/10" data-id="element-162" />

              <div className="flex gap-0.5 mb-2 md:mb-4" data-id="element-163">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 md:w-5 md:h-5 fill-gold text-gold" data-id="element-164" />)}
              </div>

              <p className="text-gray-300 mb-3 md:mb-6 relative z-10 italic text-sm md:text-base" data-id="element-165">
                "{t.quote}"
              </p>

              <div className="border-t border-gray-800 pt-2 md:pt-4" data-id="element-166">
                <p className="font-bold text-white text-sm md:text-lg" data-id="element-167">
                  {t.name}, {t.age} años
                </p>
                <p className="text-gold text-xs md:text-sm font-medium" data-id="element-168">
                  {t.specialty}
                </p>
                <p className="text-gray-500 text-xs md:text-sm" data-id="element-169">
                  {t.city}, Argentina
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}